import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight, CheckCircle2 } from "lucide-react";
import interiorImg from "@/assets/interior-inspiration.jpg";
import livingRoomImg from "@/assets/living-room-wall.jpg";
import { CALENDLY_DEMO_URL } from "@/constants/links";

export default function BookDemo() {
  return (
    <div className="min-h-screen bg-[#EFEAE4] text-[#2B1B14]">
      {/* Nav */}
      <header className="sticky top-0 z-40 bg-[#EFEAE4]/90 backdrop-blur border-b border-[#947E64]/20">
        <nav className="mx-auto max-w-6xl px-4 md:px-8 py-4 flex items-center justify-between">
          <Link to="/" className="font-serif-display text-2xl font-semibold tracking-tight text-[#2B1B14] inline-flex items-center gap-2">
            <span className="inline-block h-2 w-2 rounded-full bg-[#947E64]" />
            NEIV
          </Link>
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#624A36] hover:text-[#2B1B14] transition">
            <ArrowLeft className="h-4 w-4" /> Back to Home
          </Link>
        </nav>
      </header>

      <div className="mx-auto max-w-6xl px-4 md:px-8 py-16 md:py-24 grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
        {/* Left — info */}
        <div>
          <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-[#947E64] mb-4">Book a Demo</span>
          <h1 className="font-serif-display text-4xl md:text-5xl font-medium leading-tight tracking-tight text-[#2B1B14]">
            See NEIV in action — live, for your store.
          </h1>
          <p className="mt-5 text-[#624A36] leading-relaxed text-lg">
            We'll walk you through how NEIV helps your customers visualize furniture in their own rooms — boosting confidence and closing more sales.
          </p>

          <ul className="mt-8 space-y-4 text-sm text-[#624A36]">
            {[
              "Live product visualization walkthrough",
              "QR code setup for your showroom",
              "Sales team onboarding overview",
              "Pricing & credit packages tailored to you",
            ].map((item) => (
              <li key={item} className="flex items-start gap-3">
                <CheckCircle2 className="h-4 w-4 mt-0.5 shrink-0 text-[#947E64]" />
                {item}
              </li>
            ))}
          </ul>

          <div className="mt-10 grid grid-cols-2 gap-4">
            <img src={interiorImg} alt="Interior" className="rounded-xl h-44 w-full object-cover shadow-md" />
            <img src={livingRoomImg} alt="Living room" className="rounded-xl h-44 w-full object-cover shadow-md" />
          </div>
        </div>

        {/* Right — Calendly scheduler */}
        <div className="bg-white rounded-2xl shadow-[0_8px_40px_rgba(43,27,20,0.10)] p-4 md:p-6">
          <div className="flex items-center justify-between px-2 pb-4">
            <h2 className="font-serif-display text-2xl font-semibold text-[#2B1B14]">Pick a time that works for you</h2>
            <a
              href={CALENDLY_DEMO_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="shrink-0 inline-flex items-center gap-1 text-sm font-medium text-[#947E64] transition hover:text-[#624A36]"
            >
              Open in new tab <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>
          <iframe
            src={CALENDLY_DEMO_URL}
            title="Book a NEIV demo on Calendly"
            className="w-full h-[640px] rounded-xl border border-[#E5DDD5]"
          />
          <p className="mt-3 text-center text-xs text-[#B7A99A]">Free, no commitment. 30-minute product demo.</p>
        </div>
      </div>
    </div>
  );
}
